import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';

import { RootState } from '@/store/root.state';
import { mainModule } from '@/store/mainModule';

Vue.use(Vuex);

export const storeOptions: StoreOptions<RootState> = {
  state: {
    version: '1.0.0', // a simple property
  },
  modules: {
    mainModule,
  },
};
export default new Vuex.Store<RootState>(storeOptions);
